// import { useEffect, useRef, useState } from "react";
// import "./NewVendor.css";
// import { API_ENDPOINTS } from "../../constant/_constant";
// import usePostRequest from "../../hooks/usePostRequest";
// import SkuSearchPopUp from "./SkuSearchPopUp";
// import moment from "moment";
// import {
//   Button,
//   Card,
//   CardBody,
//   Col,
//   OverlayTrigger,
//   Row,
//   InputGroup,
//   Table,
//   Form,
//   Tooltip,
// } from "react-bootstrap";
// import DynamicPagination from "../../components/DynamicPagination ";
// import {
//   IconPlus,
//   IconUserCheck,
//   IconUserOff,
//   IconTrash,
//   IconXboxX,
//   IconCircleCheck,
//   IconCircleCheckFilled,
//   IconBuildingBank,
//   IconEye,
//   IconEdit,
//   IconPaperclip,
//   IconMessageCircle,
//   IconCreditCard,
//   IconSearch,
//   IconBox,
//   IconLayoutListFilled,
//   IconLayoutGridFilled,
// } from "@tabler/icons-react";
// import { useNavigate } from "react-router-dom";
// import ComanConfirmationModal from "../../components/ComanConfirmationModal";
// import { toast } from "react-toastify";
// import VendorCard from "./VendorCard";
// import quickbookimg from "../../assets/quickbooks.svg";
// import View_DetailsVendor from "./ViewDetail/View_DetailsVendor";
// import { useSelector } from "react-redux";
// import useIdleLogout from "../../hooks/useIdleLogout";

// const VendorListUI = () => {
//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [isSearchClicked, setIsSearchClicked] = useState(false);
//   const [isListView, setIsListView] = useState(false);
//   const [productLib, setProductLib] = useState({ show: false, autoId: null });

//   const navigate = useNavigate();
//   const [isViewOpen, setIsViewOpen] = useState({
//     show: false,
//     order: [],
//     isStatusUpdate: false,
//   });
//   const [isCardOpen, setIsCardOpen] = useState({
//     show: false,
//     auto_id: null,
//   });

//   const handleCloseCard = () => {
//     setIsCardOpen({ show: false, auto_id: null });
//     fetchVendors({ page, limit });
//   };

//   const [isModalOpen, setIsModalOpen] = useState({
//     show: false,
//     action: null,
//     user: null,
//     message: "",
//   });

//   useIdleLogout();

//   const { data: vendors, postData: fetchVendors } = usePostRequest(
//     API_ENDPOINTS.GET_VENDORS,
//   );

//   const { isLoading, postData: updateVendorStatus } = usePostRequest(
//     API_ENDPOINTS.VENDOR_STATUS,
//   );

//   const handlePageChange = (nextPage) => {
//     setPage(nextPage);
//   };

//   const handleLimitChange = (selectedLimit) => {
//     setPage(1);
//     setLimit(selectedLimit);
//   };

//   const handleNewVendor = () => {
//     navigate("/create-vendor");
//   };

//   const onStatusSuccess = (response) => {
//     toast.success(response.message);
//     fetchVendors({ page, limit });
//   };
//   const onStatusError = (error) => {
//     toast.error(error.message || "An error occurred during deactivation.");
//   };

//   const handleViewClick = (vendor) => {
//     setIsViewOpen({
//       show: true,
//       products: vendor,
//       auto_id: vendor.auto_id,
//     });

//     const currentUrl = window.location.pathname;
//     const newUrl = `${currentUrl}?${vendor.auto_id}`;
//     window.history.pushState(null, "", newUrl);
//   };

//   const handleActivateVendor = (user) => {
//     updateVendorStatus(
//       {
//         active: true,
//         auto_id: user.auto_id,
//       },
//       onStatusSuccess,
//       onStatusError,
//     );
//     setIsModalOpen({ ...isModalOpen, show: false });
//   };

//   useEffect(() => {
//     fetchVendors({
//       page,
//       limit,
//       search: searchTerm || null,
//     });
//   }, [page, limit, isSearchClicked]);

//   const handleSearchInputChange = (e) => {
//     setSearchTerm(e.target.value);
//   };

//   const handleSearch = () => {
//     setPage(1); // Reset to page 1 on new search
//     setIsSearchClicked((prev) => !prev);
//   };

//   const handleClearSearch = () => {
//     setSearchTerm("");
//     setPage(1);
//     setIsSearchClicked((prev) => !prev);
//   };

//   const handleDeactivateVendor = (user) => {
//     if (user.balance > 0) {
//       toast.error(
//         "This Vendor can't be Inactive because it has a non-zero balance.",
//       );
//       return;
//     }
//     updateVendorStatus(
//       {
//         active: false,
//         auto_id: user.auto_id,
//       },
//       onStatusSuccess,
//       onStatusError,
//     );

//     setIsModalOpen({ ...isModalOpen, show: false });
//   };

//   const openModal = (action, user) => {
//     let modalMessage = "";
//     let modalTitle = "";
//     let type = "";
//     let modalIcon = null;
//     let actionHandler = () => {};

//     if (action === "delete") {
//       type = "danger";
//       modalMessage = "Are you sure you want to delete this user?";
//       modalTitle = "Delete Vendor";
//       modalIcon = <IconTrash />;
//       // actionHandler = () => handleDeleteUser(user);
//     } else if (action === "activate") {
//       type = "warning";
//       modalMessage = "Are you sure you want to activate this user?";
//       modalTitle = "Activate Vendor";
//       modalIcon = <IconUserCheck />;
//       actionHandler = () => handleActivateVendor(user);
//     } else if (action === "deactivate") {
//       type = "warning";
//       modalMessage = "Are you sure you want to deactivate this user?";
//       modalTitle = "Deactivate Vendor";
//       modalIcon = <IconUserOff />;
//       actionHandler = () => handleDeactivateVendor(user);
//     }

//     setIsModalOpen({
//       show: true,
//       action,
//       user,
//       message: modalMessage,
//       onConfirm: actionHandler,
//       title: modalTitle,
//       icon: modalIcon,
//       type: type,
//     });
//   };

//   // useEffect(() => {
//   //   fetchVendors({ page, limit });
//   // }, [page, limit]);

//   function safeGet(objOrStr, key) {
//     try {
//       const value =
//         typeof objOrStr === "string" ? JSON.parse(objOrStr) : objOrStr;
//       return value?.[key] || "N/A";
//     } catch {
//       return "N/A";
//     }
//   }

//   const user = useSelector((state) => state.auth.user);
//   const canEditCards = user?.permissions?.manage_cards?.includes("write");
//   const canViewCards = user?.permissions?.manage_cards?.includes("read");

//   function safeGet(objOrStr, key) {
//     try {
//       const value =
//         typeof objOrStr === "string" ? JSON.parse(objOrStr) : objOrStr;
//       return value?.[key] || "N/A";
//     } catch {
//       return "N/A";
//     }
//   }

//   const searchInputRef = useRef();
//   const tableWrapperRefs = {
//     row1: useRef(null),
//     row2: useRef(null),
//     row3: useRef(null),
//     row4: useRef(null),
//     row5: useRef(null),
//     row6: useRef(null),
//   };
//   const dropdownRefs = {
//     row1: useRef(null),
//     row2: useRef(null),
//     row3: useRef(null),
//     row4: useRef(null),
//     row5: useRef(null),
//     row6: useRef(null),
//   };

//   console.log("vendorsvendors", vendors)

//   return (
//     <>
//       <View_DetailsVendor
//         auto_id={isViewOpen.auto_id}
//         isStatusUpdate={isViewOpen.isStatusUpdate}
//         onStatusUpdate={() =>
//           setIsViewOpen((prev) => ({ ...prev, isStatusUpdate: true }))
//         }
//       />
//       {isCardOpen.show && (
//         <VendorCard
//           show={isCardOpen.show}
//           setShow={handleCloseCard}
//           auto_id={isCardOpen.auto_id}
//         />
//       )}
//       <div className="page-header d-print-none">
//         <div className="row g-2 align-items-center">
//           <div className="col">
//             <h2 className="page-title">Vendor Management</h2>
//           </div>
//         </div>
//       </div>

//       <Card className="mb-3">
//         <CardBody>
//           <Form
//             onKeyDown={(e) => {
//               if (e.key === "Enter") {
//                 e.preventDefault();
//                 handleSearch();
//               }
//             }}
//           >
//             <Row className="align-items-end">
//               <Col md={9}>
//                 <Form.Label>Search Vendor</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>
//                     <IconSearch />
//                   </InputGroup.Text>
//                   <Form.Control
//                     type="text"
//                     placeholder="Search..."
//                     value={searchTerm}
//                     onChange={handleSearchInputChange}
//                   />
//                 </InputGroup>
//               </Col>
//               <Col md={3}>
//                 <div className="d-flex gap-2">
//                   <Button
//                     className="w-100"
//                     variant="warning"
//                     onClick={handleSearch}
//                   >
//                     {" "}
//                     Apply Filters{" "}
//                   </Button>
//                   <Button
//                     className="w-100"
//                     variant="outline-secondary"
//                     onClick={handleClearSearch}
//                   >
//                     Clear Filters
//                   </Button>
//                 </div>
//               </Col>
//               <Form.Text>
//                 Search by company name, vendor name, or any other relevant
//                 keyword.
//               </Form.Text>
//             </Row>
//           </Form>
//         </CardBody>
//       </Card>

//       {isListView ? null : (
//         <div className="d-flex align-items-center justify-content-end pt-2 pb-3 gap-3">
//           <div className="view-toggle d-flex align-items-center justify-content-end gap-1">
//             <IconLayoutGridFilled
//               onClick={() => setIsListView(false)}
//               style={{
//                 cursor: "pointer",
//                 color: !isListView ? "#FE6338" : "#515151",
//               }}
//             />
//             <IconLayoutListFilled
//               onClick={() => setIsListView(true)}
//               style={{
//                 cursor: "pointer",
//                 color: isListView ? "#FE6338" : "#515151",
//               }}
//             />
//           </div>
//         </div>
//       )}

//       {productLib.show && (
//         <SkuSearchPopUp
//           show={productLib.show}
//           setShow={() => setProductLib({ show: false, autoId: null })}
//           autoId={productLib.autoId}
//         />
//       )}

//       <div className="order_list_view">
//         <div
//           className="table-responsive mail_wrapper border-0 p-0"
//           ref={tableWrapperRefs.row1}
//           style={{ overflowX: "auto" }}
//         >
//           <table className="table">
//             <thead>
//               <tr>
//                 <th>Company Name</th>
//                 <th>Full Name</th>
//                 <th>Phone Number</th>
//                 <th>Created Date</th>
//                 <th>Email Address</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {vendors?.data?.length > 0 ? (
//                 vendors?.data?.map((row, index) => {
//                   return (
//                     <tr key={index}>
//                       <td>{row.display_name || "N/A"}</td>
//                       <td>
//                         {row?.first_name || row?.last_name
//                           ? `${row.first_name || ""} ${
//                               row.last_name || ""
//                             }`.trim()
//                           : "N/A"}
//                       </td>
//                       <td>
//                         {safeGet(
//                           row?.VendorContact?.primary_phone,
//                           "FreeFormNumber",
//                         )}
//                       </td>
//                       <td>{moment(row?.createdAt).format("MM/DD/YYYY")}</td>

//                       {/* other tds */}
//                       <td>
//                         {safeGet(
//                           row?.VendorContact?.primary_email,
//                           "Address",
//                         )}
//                       </td>
//                       <td style={{ position: "relative" }}>
//                         <button
//                           onClick={() => openModal(row?.id)}
//                           style={{
//                             background: "transparent",
//                             border: "none",
//                             cursor: "pointer",
//                           }}
//                           disabled={!canEditCards}
//                         >
//                           <IconEdit size={20} />
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan="9" className="text-center">
//                     No data found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//           {/* {vendors?.data?.length >= 10 && hasMoreDraft && (
//             <div className="text-center mt-3">
//               <Button
//                 variant="outline-primary"
//                 onClick={handleLoadMoreDraft}
//                 disabled={loadingDraft}
//               >
//                 {loadingDraft ? "Loading..." : "Load More"}
//               </Button>
//             </div>
//           )} */}
//         </div>
//       </div>
//     </>
//   );
// };

// export default VendorListUI;

import { useEffect, useRef, useState } from "react";
import "./NewVendor.css";
import { API_ENDPOINTS } from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import SkuSearchPopUp from "./SkuSearchPopUp";
import moment from "moment";
import {
  Button,
  Card,
  CardBody,
  Col,
  OverlayTrigger,
  Row,
  InputGroup,
  Table,
  Form,
  Tooltip,
} from "react-bootstrap";
import {
  IconPlus,
  IconUserCheck,
  IconUserOff,
  IconTrash,
  IconXboxX,
  IconCircleCheck,
  IconCircleCheckFilled,
  IconBuildingBank,
  IconEye,
  IconEdit,
  IconPaperclip,
  IconMessageCircle,
  IconCreditCard,
  IconSearch,
  IconBox,
  IconLayoutListFilled,
  IconLayoutGridFilled,
  IconPencil,
  IconChevronRight,
  IconHistoryToggle,
  IconFileTypePdf,
  IconMailSpark,
  IconDotsVertical,
} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import ComanConfirmationModal from "../../components/ComanConfirmationModal";
import { toast } from "react-toastify";
import VendorCard from "./VendorCard";
import quickbookimg from "../../assets/quickbooks.svg";
import View_DetailsVendor from "./ViewDetail/View_DetailsVendor";
import { useSelector } from "react-redux";
import useIdleLogout from "../../hooks/useIdleLogout";
import VendorListing from "./VendorListing";

const VendorListUI = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [isListView, setIsListView] = useState(true);
  const [productLib, setProductLib] = useState({ show: false, autoId: null });
  const [vendorData, setVendorData] = useState([]);
  const [hasMoreVendors, setHasMoreVendors] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (id) => {
    const isOpening = openDropdown !== id;
    setOpenDropdown(isOpening ? id : null);
    if (tableWrapperRefs.row1?.current) {
      tableWrapperRefs.row1.current.style.overflow = isOpening
        ? "visible"
        : "auto";
    }
  };

  const navigate = useNavigate();
  const [isViewOpen, setIsViewOpen] = useState({
    show: false,
    order: [],
    isStatusUpdate: false,
  });
  const [isCardOpen, setIsCardOpen] = useState({
    show: false,
    auto_id: null,
  });

  const handleCloseCard = () => {
    setIsCardOpen({ show: false, auto_id: null });
    setPage(1);
    setIsSearchClicked((prev) => !prev);
  };

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    user: null,
    message: "",
  });

  useIdleLogout();

  const {
    data: vendors,
    isLoading: loadingVendors,
    postData: fetchVendors,
  } = usePostRequest(API_ENDPOINTS.GET_VENDORS);

  const { isLoading, postData: updateVendorStatus } = usePostRequest(
    API_ENDPOINTS.VENDOR_STATUS,
  );

  const handleNewVendor = () => {
    navigate("/create-vendor");
  };

  const onSuccessfulFetchVendors = (response, reset = false) => {
    if (!response?.data || response.data.length < limit) {
      setHasMoreVendors(false);
    } else {
      setHasMoreVendors(true);
    }
    setVendorData((prevData) => {
      const combined = reset
        ? response?.data || []
        : [...prevData, ...(response?.data || [])];
      const unique = Array.from(
        new Map(combined.map((item) => [item.auto_id, item])).values(),
      );
      return unique;
    });
  };

  const onStatusSuccess = (response) => {
    toast.success(response.message);
    setPage(1);
    setIsSearchClicked((prev) => !prev);
  };
  const onStatusError = (error) => {
    toast.error(error.message || "An error occurred during deactivation.");
  };

  const handleViewClick = (vendor) => {
    handleClickOutside();
    // console.log("vendorvendor", vendor)
    setIsViewOpen({
      show: true,
      products: vendor,
      auto_id: vendor.auto_id,
    });

    const currentUrl = window.location.pathname;
    const newUrl = `${currentUrl}?${vendor.auto_id}`;
    window.history.pushState(null, "", newUrl);
  };

  const handleActivateVendor = (user) => {
    updateVendorStatus(
      {
        active: true,
        auto_id: user.auto_id,
      },
      onStatusSuccess,
      onStatusError,
    );
    setIsModalOpen({ ...isModalOpen, show: false });
  };

  useEffect(() => {
    fetchVendors(
      {
        page,
        limit,
        search: searchTerm || null,
      },
      (response) => onSuccessfulFetchVendors(response, page === 1),
    );
  }, [page, limit, isSearchClicked]);

  const handleLoadMore = () => {
    if (hasMoreVendors && !loadingVendors) {
      setPage((prev) => prev + 1);
    }
  };

  const handleSearchInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    setPage(1);
    setVendorData([]);
    setHasMoreVendors(true);
    setIsSearchClicked((prev) => !prev);
  };

  const handleClearSearch = () => {
    console.log("clear function ran");
    setSearchTerm("");
    setPage(1);
    setVendorData([]);
    setHasMoreVendors(true);
    setIsSearchClicked((prev) => !prev);
  };

  const handleDeactivateVendor = (user) => {
    if (user.balance > 0) {
      toast.error(
        "This Vendor can't be Inactive because it has a non-zero balance.",
      );
      return;
    }
    updateVendorStatus(
      {
        active: false,
        auto_id: user.auto_id,
      },
      onStatusSuccess,
      onStatusError,
    );

    setIsModalOpen({ ...isModalOpen, show: false });
  };

  const openModal = (action, user) => {
    let modalMessage = "";
    let modalTitle = "";
    let type = "";
    let modalIcon = null;
    let actionHandler = () => {};

    if (action === "delete") {
      type = "danger";
      modalMessage = "Are you sure you want to delete this user?";
      modalTitle = "Delete Vendor";
      modalIcon = <IconTrash />;
    } else if (action === "activate") {
      type = "warning";
      modalMessage = "Are you sure you want to activate this user?";
      modalTitle = "Activate Vendor";
      modalIcon = <IconUserCheck />;
      actionHandler = () => handleActivateVendor(user);
    } else if (action === "deactivate") {
      type = "warning";
      modalMessage = "Are you sure you want to deactivate this user?";
      modalTitle = "Deactivate Vendor";
      modalIcon = <IconUserOff />;
      actionHandler = () => handleDeactivateVendor(user);
    }

    setIsModalOpen({
      show: true,
      action,
      user,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  function safeGet(objOrStr, key) {
    try {
      const value =
        typeof objOrStr === "string" ? JSON.parse(objOrStr) : objOrStr;
      return value?.[key] || "N/A";
    } catch {
      return "N/A";
    }
  }

  const user = useSelector((state) => state.auth.user);
  const canEditCards = user?.permissions?.manage_cards?.includes("write");
  const canViewCards = user?.permissions?.manage_cards?.includes("read");

  const searchInputRef = useRef();
  const tableWrapperRefs = {
    row1: useRef(null),
    row2: useRef(null),
    row3: useRef(null),
    row4: useRef(null),
    row5: useRef(null),
    row6: useRef(null),
  };
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event?.target)) {
      setOpenDropdown(null);
      if (tableWrapperRefs.row1?.current) {
        tableWrapperRefs.row1.current.style.overflow = "auto";
      }
    }
  };
  useEffect(() => {
    if (!openDropdown) return;
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openDropdown]);

  return (
    <>
      <View_DetailsVendor
        auto_id={isViewOpen.auto_id}
        isStatusUpdate={isViewOpen.isStatusUpdate}
        onStatusUpdate={() =>
          setIsViewOpen((prev) => ({ ...prev, isStatusUpdate: true }))
        }
      />
      {isCardOpen.show && (
        <VendorCard
          show={isCardOpen.show}
          setShow={handleCloseCard}
          auto_id={isCardOpen.auto_id}
        />
      )}
      {isListView ? (
        <div className="page-header d-print-none">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Vendor Management</h2>
            </div>
          </div>
        </div>
      ) : null}

      {isListView ? (
        <Card className="mb-3">
          <CardBody>
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSearch();
                }
              }}
            >
              <Row className="align-items-end">
                <Col md={9}>
                  <Form.Label>Search Vendor</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <IconSearch />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search..."
                      value={searchTerm}
                      onChange={handleSearchInputChange}
                    />
                  </InputGroup>
                </Col>
                <Col md={3}>
                  <div className="d-flex gap-2">
                    <Button
                      className="w-100"
                      variant="warning"
                      onClick={handleSearch}
                    >
                      {" "}
                      Apply Filters{" "}
                    </Button>
                    <Button
                      className="w-100"
                      variant="outline-secondary"
                      onClick={handleClearSearch}
                    >
                      Clear Filters
                    </Button>
                  </div>
                </Col>
                <Form.Text>
                  Search by company name, vendor name, or any other relevant
                  keyword.
                </Form.Text>
              </Row>
            </Form>
          </CardBody>
        </Card>
      ) : null}
      {isListView ? (
        <div className="d-flex align-items-center justify-content-end pt-2 pb-3 gap-3">
          <div className="view-toggle d-flex align-items-center justify-content-end gap-1">
            <IconLayoutGridFilled
              onClick={() => setIsListView(false)}
              style={{
                cursor: "pointer",
                color: !isListView ? "#FE6338" : "#515151",
              }}
            />
            <IconLayoutListFilled
              onClick={() => setIsListView(true)}
              style={{
                cursor: "pointer",
                color: isListView ? "#FE6338" : "#515151",
              }}
            />
          </div>
        </div>
      ) : null}

      {productLib.show && (
        <SkuSearchPopUp
          show={productLib.show}
          setShow={() => setProductLib({ show: false, autoId: null })}
          autoId={productLib.autoId}
        />
      )}

      {isListView ? (
        <div className="order_list_view">
          <div
            className="table-responsive mail_wrapper border-0 p-0"
            ref={tableWrapperRefs.row1}
            style={{ overflowX: "auto" }}
          >
            <table className="table">
              <thead>
                <tr>
                  <th>Company Name</th>
                  <th>Full Name</th>
                  <th>Phone Number</th>
                  <th>Created Date</th>
                  <th>Email Address</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {vendorData.length > 0 ? (
                  vendorData.map((row, index) => {
                    return (
                      <tr key={index}>
                        <td>{row.display_name || "N/A"}</td>
                        <td>
                          {row?.first_name || row?.last_name
                            ? `${row.first_name || ""} ${
                                row.last_name || ""
                              }`.trim()
                            : "N/A"}
                        </td>
                        <td>
                          {safeGet(
                            row?.VendorContact?.primary_phone,
                            "FreeFormNumber",
                          )}
                        </td>
                        <td>{moment(row?.createdAt).format("MM/DD/YYYY")}</td>
                        <td>
                          {safeGet(
                            row?.VendorContact?.primary_email,
                            "Address",
                          )}
                        </td>
                        <td style={{ position: "relative" }}>
                          <button
                            onClick={() => toggleDropdown(row.auto_id)}
                            style={{
                              background: "transparent",
                              border: "none",
                              cursor: "pointer",
                            }}
                          >
                            <IconDotsVertical size={20} />
                          </button>
                          {openDropdown === row.auto_id && (
                            <ul
                              ref={dropdownRef}
                              className="order-dropdown-menu p-0"
                            >
                              <li
                                className="dropdown-item"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`/edit-vendor/${row?.auto_id}`);
                                }}
                              >
                                <span>
                                  <IconPencil stroke={1} /> Edit
                                </span>
                                <IconChevronRight stroke={1} />
                              </li>
                              <li
                                className="dropdown-item border-top"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleViewClick(row);
                                }}
                              >
                                <span>
                                  <IconEye stroke={1} /> View Details
                                </span>
                                <IconChevronRight stroke={1} />
                              </li>
                              <li
                                className="dropdown-item border-top"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickOutside();
                                  setProductLib({
                                    show: true,
                                    autoId: row?.auto_id,
                                  });
                                }}
                              >
                                <span>
                                  <IconBox stroke={1} /> X Products
                                </span>
                                <IconChevronRight stroke={1} />
                              </li>
                              <li
                                className="dropdown-item border-top"
                                style={{
                                  cursor: !canViewCards
                                    ? "not-allowed"
                                    : "auto",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickOutside();
                                  if (canViewCards) {
                                    setIsCardOpen({
                                      show: true,
                                      auto_id: row.auto_id,
                                    });
                                  }
                                }}
                              >
                                <span>
                                  <IconBuildingBank stroke={1} /> Payment
                                  Details
                                </span>
                                <IconChevronRight stroke={1} />
                              </li>
                              <li className="border-top">
                                <div className="rfq_lis_short justify-content-center p-2">
                                  <span>
                                    <IconCreditCard stroke={1} />{" "}
                                    {row.detailsCount ?? 0}
                                  </span>
                                  <span>
                                    <IconPaperclip stroke={1} />{" "}
                                    {row.Attachments?.length ?? 0}
                                  </span>
                                  <span>
                                    <IconMessageCircle stroke={1} />{" "}
                                    {row.section.reduce((acc, section) => {
                                      return acc + section.notes.length;
                                    }, 0)}
                                  </span>
                                </div>
                              </li>
                            </ul>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {vendorData.length >= 10 && hasMoreVendors && (
              <div className="text-center mt-3">
                <Button
                  variant="outline-primary"
                  onClick={handleLoadMore}
                  disabled={loadingVendors}
                >
                  {loadingVendors ? "Loading..." : "Load More"}
                </Button>
              </div>
            )}
          </div>
        </div>
      ) : (
        <VendorListing />
      )}
      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => setIsModalOpen({ ...isModalOpen, show: false })}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />
    </>
  );
};

export default VendorListUI;
